import { Options } from 'react-select';

import { TimeSeriesGranularity } from 'dashboards/types/time';

import { Select, SelectProps } from 'components/Select/Select';

type GranularityOption = { value: TimeSeriesGranularity; label: string };

const GRANULARITY_OPTIONS: Options<GranularityOption> = [
  { value: 'AUTO', label: 'Auto' },
  { value: 'MINUTE', label: 'Minute' },
  { value: 'FIVE_MINUTES', label: '5 minutes' },
  { value: 'TEN_MINUTES', label: '10 minutes' },
  { value: 'FIFTEEN_MINUTES', label: '15 minutes' },
  { value: 'HOUR', label: 'Hour' },
  { value: 'DAY', label: 'Day' },
  { value: 'WEEK', label: 'Week' },
  { value: 'MONTH', label: 'Month' },
  { value: 'YEAR', label: 'Year' },
];

type GranularitySelectProps = Omit<
  SelectProps<GranularityOption>,
  'value' | 'onChange'
> & {
  value?: TimeSeriesGranularity;
  onChange?: (value?: TimeSeriesGranularity) => void;
};

/** Timeseries granularity presets. */
export function GranularitySelect({
  value: granularity,
  onChange,
  ...props
}: GranularitySelectProps) {
  return (
    <Select
      {...props}
      value={GRANULARITY_OPTIONS.find(({ value }) => value === granularity)}
      onChange={(option) => onChange?.(option?.value)}
      options={GRANULARITY_OPTIONS}
    />
  );
}
